import { Transform } from 'class-transformer';
import { stringToBoolean, stringToBooleanNullable } from '../../types-transformers/boolean-transformers';
import { PaginationFilter } from '../../interfaces/filters/pagination.filter';
import { AcceptanceOptionsEnum } from '../../enums/acceptance-options.enum';
import { OrderParamPair } from "../../interfaces/filters/order-param-pair";
import { UserDto } from "../dto";
import { OrderFilter } from "../../interfaces/filters/order.filter";
import { jsonStringToObject } from "../../types-transformers/order-transformers";

export class UserSubscriptionsFilter implements PaginationFilter, OrderFilter<UserDto> {
	@Transform(stringToBooleanNullable)
	public isMutual?: boolean | null;

	@Transform(stringToBooleanNullable)
	public isCommunityProfile?: boolean;

	@Transform(stringToBoolean)
	public includeCurrentAdminRelatedData?: boolean | null;

	public search?: string | null;

	public acceptanceStatusesIds?: AcceptanceOptionsEnum[];

	public pageSize?: number | null;
	public page?: number | null;

	@Transform(jsonStringToObject)
	public orderedBy?: OrderParamPair<UserDto>[] | null;
}

export class ExtendedUserSubscriptionsFilter extends UserSubscriptionsFilter {
	public eventIdToGetNotInvitedUsers?: string | null;
	public chatCidToGetNonMembers?: string | null;
}
